import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  // 홈 목록에서 보여 줄 주제(stage). 미선택이면 첫 stage를 쓴다.
  currentSpeakingStageKey: string | null;
}

const initialState: IState = {
  currentSpeakingStageKey: null,
};

const speakingSlice = createSlice({
  name: 'speaking',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    storeCurrentSpeakingStageKey: (state, action: PayloadAction<string | null>) => {
      state.currentSpeakingStageKey = action.payload;
    },
  },
});

export const { actions, reducer } = speakingSlice;
export default speakingSlice.reducer;
